export default __webpack_public_path__ + "static/media/r77-rewards.492d26fe.svg";